import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Input } from '@alfa-bank/site-input';

import type { TPhoneInput, IDeps } from './models';
import { PhoneInput as Component } from './phone-input';
import styles from './styles/styles.css';

export const PhoneInput = createWidget<IDeps, TPhoneInput>({ Input, styles })(Component);
